import FlightStayApp from '@/features/flightstay/App';
import './flightstay.css';

export function FlightStayPage() {
  return <div className="flightstay-scope"><FlightStayApp /></div>;
}